module.exports = (require("./helpers/browser/import-polyfill")(parcelRequire.resolve("cK8zQ"))).then(() => parcelRequire('5pFC1'));